import './animations.js';

document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on a mobile device
    const isMobile = window.innerWidth <= 768;
    
    // Cursor effect (only for desktop)
    if (!isMobile) {
        const cursor = document.querySelector('.cursor');
        document.addEventListener('mousemove', (e) => {
            cursor.style.left = e.clientX + 'px';
            cursor.style.top = e.clientY + 'px';
        });
    }

    // Countdown timer
    const countdownDate = new Date('May 10, 2025 13:00:00').getTime();
    
    function updateCountdown() {
        const now = new Date().getTime();
        const distance = countdownDate - now;
        
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        document.getElementById('days').innerHTML = days.toString().padStart(2, '0');
        document.getElementById('hours').innerHTML = hours.toString().padStart(2, '0');
        document.getElementById('minutes').innerHTML = minutes.toString().padStart(2, '0');
        document.getElementById('seconds').innerHTML = seconds.toString().padStart(2, '0');
        
        if (distance < 0) {
            clearInterval(countdownInterval);
            document.getElementById('days').textContent = '00';
            document.getElementById('hours').textContent = '00';
            document.getElementById('minutes').textContent = '00';
            document.getElementById('seconds').textContent = '00';
        }
    }
    
    updateCountdown();
    const countdownInterval = setInterval(updateCountdown, 1000);

    // Parallax effect for stars (simplified for mobile)
    if (!isMobile) {
        document.addEventListener('mousemove', (e) => {
            const stars = document.querySelector('.stars');
            const x = e.clientX / window.innerWidth;
            const y = e.clientY / window.innerHeight;
            
            stars.style.transform = `translate(${x * 20}px, ${y * 20}px)`;
        });
    } else {
        // Subtle movement for mobile based on device orientation
        window.addEventListener('deviceorientation', (e) => {
            if (e.beta && e.gamma) {
                const stars = document.querySelector('.stars');
                const x = e.gamma / 60; // -60 to 60 degrees
                const y = e.beta / 180; // -180 to 180 degrees
                
                stars.style.transform = `translate(${x * 10}px, ${y * 10}px)`;
            }
        });
    }

    // Reveal animations on scroll - optimized for mobile
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);
    
    document.querySelectorAll('.event-info').forEach(el => {
        observer.observe(el);
    });

    // Modal and button handlers
    const modal = document.getElementById('responseModal');
    const modalMessage = document.getElementById('modalMessage');
    const closeModal = document.querySelector('.close-modal');
    
    function showModal(message) {
        modalMessage.innerHTML = message;
        modal.style.display = 'flex';
    }
    
    closeModal.addEventListener('click', () => {
        modal.style.display = 'none';
    });
    
    window.addEventListener('click', (e) => {
        if (e.target === modal) {
            modal.style.display = 'none';
        }
    });
    
    // Yes button with confetti effect
    const yesBtn = document.getElementById('yesBtn');
    yesBtn.addEventListener('click', () => {
        const message = `
            <h2>Can't Wait 🕺</h2>
            <p>Looking forward to seeing you on May 10th</p>
            <p>😊</p>
        `;
        
        showModal(message);
        // Launch confetti after showing modal
        setTimeout(() => {
            launchConfetti();
        }, 200);
    });
    
    // Maybe button
    const maybeBtn = document.getElementById('maybeBtn');
    maybeBtn.addEventListener('click', () => {
        const message = `
             <h2>Can't Wait 🕺🕺🕺</h2>
             <p>Looking forward to seeing you on May 10th</p>
             <p>😊</p>
        `;
        
        showModal(message);
        // Launch confetti after showing modal
        setTimeout(() => {
            launchConfetti();
        }, 200);
    });

    // Confetti effect - optimized for mobile
    function launchConfetti() {
        const duration = 3 * 1000; // Reduced back to 3 seconds
        const animationEnd = Date.now() + duration;
        const defaults = { 
            startVelocity: isMobile ? 25 : 35, // Slightly reduced velocity
            spread: isMobile ? 300 : 360, // Reduced spread
            ticks: 60, 
            zIndex: 150, // Higher than modal
            particleCount: isMobile ? 40 : 60, // Reduced particle count
            scalar: isMobile ? 1.1 : 1, 
            colors: ['#FFD700', '#008751', '#ffffff'] // Reduced to Nigerian colors
        };
        
        function randomInRange(min, max) {
            return Math.random() * (max - min) + min;
        }
        
        // Launch confetti from sides
        confetti({
            ...defaults,
            origin: { x: 0.2, y: 0.8 } // Bottom left
        });
        
        confetti({
            ...defaults,
            origin: { x: 0.8, y: 0.8 } // Bottom right
        });
        
        // On desktop, add one more source
        if (!isMobile) {
            confetti({
                ...defaults,
                origin: { x: 0.5, y: 0.7 } // Bottom center
            });
        }
    }

    // Add event effects to cards based on device
    const eventInfoCards = document.querySelectorAll('.event-info');
    
    if (isMobile) {
        // Touch effects for mobile
        eventInfoCards.forEach(card => {
            card.addEventListener('touchstart', () => {
                // card.style.transform = 'translateY(-5px)';
                // card.style.boxShadow = '0 6px 15px rgba(0, 0, 0, 0.12)';
            });
            
            card.addEventListener('touchend', () => {
                setTimeout(() => {
                    // card.style.transform = 'translateY(0)';
                    // card.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.08)';
                }, 150);
            });
        });
    } else {
        // Mouse effects for desktop
        eventInfoCards.forEach(card => {
            card.addEventListener('mouseenter', () => {
                // card.style.transform = 'translateY(-10px)';
                // card.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
            });
            
            card.addEventListener('mouseleave', () => {
                // card.style.transform = 'translateY(0)';
                // card.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.08)';
            });
        });
    }

    // Handle window resize to adjust for mobile/desktop
    window.addEventListener('resize', () => {
        const newIsMobile = window.innerWidth <= 768;
        if (newIsMobile !== isMobile) {
            // Reload the page if we cross the mobile/desktop threshold
            window.location.reload();
        }
    });

    // Preload images and resources for smoother experience
    function preloadResources() {
        // Force the browser to load icons
        const fontAwesomeLink = document.querySelector('link[href*="font-awesome"]');
        if (fontAwesomeLink) {
            const tempIcon = document.createElement('i');
            tempIcon.className = 'fas fa-coffee fas fa-film fas fa-gamepad';
            tempIcon.style.position = 'absolute';
            tempIcon.style.opacity = '0';
            document.body.appendChild(tempIcon);
            setTimeout(() => document.body.removeChild(tempIcon), 100);
        }
    }
    
    preloadResources();
}); 